<template>
  <div class="gallery--chars col-xs-12">
    <div
      class="chars-title filter--title"
      @click="window.width < 767 ? mobile() : ''"
    >
      A-Z <i class="fas fa-angle-down" ref="iconDown"></i>
    </div>
    <span class="chars-container" ref="chars">
      <button id="all" class="active" @click="filterChars('')">
        {{ translations.all }}
      </button>
      <ul>
        <li v-for="(char, i) in chars" :key="i">
          <button
            :id="i"
            :class="[char ? '' : 'disabled']"
            :disabled="!char"
            @click="filterChars(i)"
            v-text="i === '0' ? '#' : i"
          ></button>
        </li>
      </ul>
    </span>
  </div>
</template>

<script lang="js">
import axios from "axios";

export default {
  name: 'Chars',
  props: ["translations", "config", "dataResult", "showElements"],
  data() {
    return {
      disabled: '',
      chars: {
        "0": false,
        "a": false,
        "b": false,
        "c": false,
        "d": false,
        "e": false,
        "f": false,
        "g": false,
        "h": false,
        "i": false,
        "j": false,
        "k": false,
        "l": false,
        "m": false,
        "n": false,
        "o": false,
        "p": false,
        "q": false,
        "r": false,
        "s": false,
        "t": false,
        "u": false,
        "v": false,
        "w": false,
        "x": false,
        "y": false,
        "z": false
      },
      currentFilter: 'all',
      oldCurrentFilter: 'all',
      list: {},
      window: {
        width: 0
      }
    };
  },
  watch: {
    'dataResult'() {
      this.$emit('update:dataResult', this.dataResult);
    }
  },
  created() {
    this.getActiveChars();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    refreshList(availableChars) {
      for (let i = 0; i < availableChars.length; i++) {
        this.chars[availableChars[i]] = true;
      }
    },
    getActiveChars() {
      axios
          .get(this.config.availableChars)
          .then(response => {
            this.refreshList(response.data);
          })
          .catch(function (error) {
            document.getElementById("gallery").innerHTML = error;
          });
    },
    filterChars(char) {
      let charActiveButton = document.getElementById(this.currentFilter);
      charActiveButton.classList.remove('active');

      if (this.currentFilter !== char) {
        this.dataResult.firstChar = char;
        if (char === '') {
          this.currentFilter = 'all';
        } else {
          this.currentFilter = char;
        }
        document.getElementById(this.currentFilter).classList.add('active');
      } else {
        this.dataResult.firstChar = '';
        this.currentFilter = 'all';
        document.getElementById(this.currentFilter).classList.add('active');
      }

      this.refreshGalleryList();
    },
    refreshGalleryList() {
      const json = JSON.stringify(this.dataResult);
      const url = this.config.filter + '?language=' + this.config.language + '&size=' + this.showElements;
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      axios.post(url, json, config)
          .then(response => {
            this.list = response.data.gallerieSearchList;
            this.$emit('update-gallery', this.list, response.data.totalPages);
          })
          .catch(e => {
            console.log(e);
          });
    },
    handleResize() {
      this.window.width = window.innerWidth;
    },
    mobile() {
      this.$refs.chars.classList.toggle('active');
      this.$refs.iconDown.classList.toggle('active');
    }
  }
};
</script>
